/* eslint-disable no-console */
import { useEffect, useMemo, useState } from "react";

import { ISimpliciAuthContainer } from "global-states";

import { ROUTES } from "constants/routes";
import { useInstance } from "hooks";
import GlobalInstanceManager from "instance-manger";
import { SITE_META } from "utils";

import "./simplici-auth-container.scss";
import "remixicon/fonts/remixicon.css";
import Main from "views/main";
import { SignIn, useSignin, useSignUp } from "views";

let isLoaded = false;
const SimpliciAuthContainer = (props: ISimpliciAuthContainer) => {
  const { setCurrentScreen, setWebComponentConfig } = useInstance();
  const signin = useSignin();
  const signup = useSignUp();
  const [loading, setLoading] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());

  useEffect(() => {
    if (!isLoaded) {
      isLoaded = true;
      props?.on_loaded?.();
    }

    (window as any).handleHooks = async (data: any, from = "login") => {
      if (from === "login") {
        if (data.payload) {
          return await (signin as any)[data.name]?.(data.payload);
        } else {
          return await (signin as any)[data.name]?.();
        }
      } else {
        if (data.payload) {
          return await (signup as any)[data.name]?.(data.payload);
        } else {
          return await (signup as any)[data.name]?.();
        }
      }
    };
    if (props.sso_user_data) {
      const param = JSON.parse(props.sso_user_data);
      if (param.type === "login") {
        setCurrentScreen("signin");
        signin.handleSignInSSO(param);
      } else {
        setCurrentScreen("signup");
        signup.handleSignUpSSO(param);
      }
      return;
    }

    // Set up GlobalInstanceManager props first
    if (!props.instance_id && !params.instance_id) {
      setCurrentScreen(ROUTES.LOADING);
    } else if (Object.keys(props).length) {
      GlobalInstanceManager.setWebComponentProps({
        ...props,
        ...(props.verified_user && {
          verified_user:
            typeof props.verified_user === "object"
              ? props.verified_user
              : JSON.parse(props.verified_user ?? "{}"),
        }),
        iscombinedinput: props.iscombinedinput === "true",
        hide_navigation: props.hide_navigation === "true",
        apiUrl: SITE_META[props.env as "prod"]?.apiUrl,
      });
    } else if (Object.keys(params).length) {
      GlobalInstanceManager.setWebComponentProps({
        ...params,
        apiUrl: SITE_META[params.env as "prod"]?.apiUrl,
        iscombinedinput: props.iscombinedinput === "true",
        hide_navigation: props.hide_navigation === "true",
        auto_navigate: props.auto_navigate === "true",
        verified_user:
          typeof props.verified_user === "object"
            ? props.verified_user
            : JSON.parse(props.verified_user as any),
        on_loaded: (event: any) => console.log("on_load", { event }),
        on_error: (event: any) => console.log("on_error", { event }),
        on_complete: (event: any) => console.log("on_complete:", event),
        on_step_change: (event: any) => console.log("on_step_change:", event),
      });
    } else {
      setCurrentScreen(ROUTES.LOADING);
    }
    if (props.page === ROUTES.SIGNUP) {
      setCurrentScreen(ROUTES.SIGNUP);
    } else {
      setCurrentScreen(ROUTES.SIGNIN);
    }

    setWebComponentConfig((prev) => ({
      ...prev,
      iscombinedinput: props.iscombinedinput === "true",
    }));

    // After setting up, initialize the instance

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  useEffect(() => {
    if (
      (params.userId && params.instance_id && window.opener && params.email) ||
      params.errorCode
    ) {
      setLoading(true);
      if (window.opener) {
        window.opener.postMessage(params, "*");
      }
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { instance_id, lang, env } = useMemo(() => {
    return {
      instance_id: props.instance_id ?? params.instance_id,
      lang: props.lang ?? params.lang,
      env: props.env ?? params.env,
    };
  }, [
    params.env,
    params.instance_id,
    params.lang,
    props.env,
    props.instance_id,
    props.lang,
  ]);

  if (!instance_id || !env || loading) {
    return <SignIn loading />;
  }

  return <Main instance_id={instance_id} lang={lang} env={env} />;
};

export default SimpliciAuthContainer;
